import { ErrorMessage, FieldArray, Form, Formik } from 'formik';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import _actions from '../actions';
import DateTimeInfo from '../components/common/DateTimeInfo';
import ExpiredPackages from '../components/common/ExpiredPackages';
import { FormBackButton } from '../components/common/FormBackButton';
import { FormHeader } from '../components/common/FormHeader';
import { FormReset } from '../components/common/FormReset';
import { FormResetButton } from '../components/common/FormResetButton';
import { FormSubheader } from '../components/common/FormSubheader';
import { FormSubmit } from '../components/common/FormSubmit';
import { FormSubmitButton } from '../components/common/FormSubmitButton';
import { FormWrapper } from '../components/common/FormWrapper';
import { AddOnGuestInfo } from '../components/package/AddOnGuestInfo';
import emptySale from '../models/sale';
import { first } from '../utils';
import addOnKey from '../utils/addOnKey';
import emailRegex from '../utils/emailRegex';
import mapGuestValuesToAddOnGuests from '../utils/mapGuestValuesToAddOnGuests';
import packageKey from '../utils/packageKey';
import './GuestInfo.scss';
import ReservationTimer from './ReservationTimer';
import zipRegex from '../utils/zipRegex';

const GuestInfoContainer = ({ sale, actions, done, config, inventory }) => {
  const [sharedAddress, setSharedAddress] = useState(false);

  const inventoryPkgs = inventory.packages[packageKey(sale.day)] || [];

  useEffect(() => {
    if (sale.id == null || sale.day == null || Object.keys(sale.packages) < 1) {
      return actions.transitionTo('/');
    }

    if (done) {
      return actions.transitionTo('/thanks');
    }
  }, []);

  const uniqueIdsForValues = () => {
    let ids = {};
    const inventoryPkgs = inventory.packages[packageKey(sale.day)] || [];

    Object.keys(sale.packageAddOns).forEach(pkgId => {
      const pkg = first(inventoryPkgs, p => p.item_id == pkgId);
      const addOns = inventory.addOns[addOnKey(sale.day, pkg)] || [];

      addOns.forEach(addOn => {
        sale.packageAddOns[pkgId];
        const pkgAddOnQuantity = sale.packageAddOns[pkgId][addOn.item_id].qty;

        for (var i = 0; i < pkgAddOnQuantity; i++) {
          const fieldPrefix = `${addOn.item_id}-${pkgId}-${i}`;
          ids[`${fieldPrefix}-first_name`] = '';
          ids[`${fieldPrefix}-last_name`] = '';
          ids[`${fieldPrefix}-email_init`] = '';
          ids[`${fieldPrefix}-email_confirm`] = '';
          ids[`${fieldPrefix}-birth_date`] = '';
          ids[`${fieldPrefix}-address`] = '';
          ids[`${fieldPrefix}-city`] = '';
          ids[`${fieldPrefix}-state`] = '';
          ids[`${fieldPrefix}-zip`] = '';
        }
      });
    });

    return ids;
  };

  return (
    <FormWrapper>
      <FormHeader>
        <ReservationTimer sale={sale}>
          Buy Tickets: Add Guest Information
        </ReservationTimer>
      </FormHeader>
      <FormSubheader>
        <DateTimeInfo date={sale.day} config={config} />
        <ExpiredPackages sale={sale} actions={actions} />
      </FormSubheader>
      <Formik
        initialValues={uniqueIdsForValues()}
        validate={values => {
          const errors = {};

          Object.keys(values).forEach(k => {
            var val = values[k];

            if (k.indexOf('first_name') > -1) {
              if (val == null || val == '') {
                errors[k] = 'First name is required';
              }
            }

            if (k.indexOf('last_name') > -1) {
              if (val == null || val == '') {
                errors[k] = 'Last name is required';
              }
            }

            if (k.indexOf('email_init') > -1) {
              if (val == null || val == '' || !emailRegex.test(val.trim())) {
                errors[k] = 'Email is required';
              }
            }

            const keyIdx = k.indexOf('email_confirm');
            if (keyIdx > -1) {
              const email_init =
                values[
                  Object.keys(values).filter(
                    _k => _k.indexOf(`${k.substr(0, keyIdx)}email_init`) > -1
                  )[0]
                ];
              if (val != email_init) {
                errors[k] = "Please confirm the guest's Email";
              }
            }

            if (k.indexOf('birth_date') > -1) {
              if (val == null || val == '') {
                errors[k] = 'Birthday is required';
              }
            }
            if (k.indexOf('address') > -1) {
              if (val == null || val == '') {
                errors[k] = 'Address is required';
              }
            }
            if (k.indexOf('city') > -1) {
              if (val == null || val == '') {
                errors[k] = 'City is required';
              }
            }
            if (k.indexOf('state') > -1) {
              if (val == null || val == '') {
                errors[k] = 'State is required';
              }
            }
            if (k.indexOf('zip') > -1) {
              if (val == null || val == '' || !zipRegex.test(val.trim())) {
                errors[k] = 'Zip is required';
              }
            }
          });

          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(true);
          actions.updateSale({
            packageAddOnGuests: mapGuestValuesToAddOnGuests(values)
          });

          setSubmitting(false);
          actions.transitionTo('/review');
        }}
      >
        {({ isSubmitting, setFieldValue, values, handleChange }) => {
          const disabled = isSubmitting;
          return (
            <Form>
              <FieldArray
                name="packageAddOnGuestInfo"
                render={() => {
                  {
                    return Object.keys(sale.packages).map(pkgId => {
                      const pkg = first(inventoryPkgs, p => p.item_id == pkgId);
                      if (pkg == null) return null;
                      const addOns =
                        inventory.addOns[addOnKey(sale.day, pkg)] || [];
                      const numPkgs = sale.packages[pkgId].qty;
                      return (
                        <AddOnGuestInfo
                          config={config}
                          key={pkgId}
                          disabled={disabled}
                          addOns={addOns}
                          pkgAddOns={sale.packageAddOns[pkgId]}
                          pkg={pkg}
                          num={numPkgs}
                          salePkg={sale.packages[pkgId]}
                          sale={sale}
                          setFieldValue={setFieldValue}
                          sharedAddress={sharedAddress}
                          setSharedAddress={setSharedAddress}
                          values={values}
                          handleChange={handleChange}
                        />
                      );
                    });
                  }
                }}
              />
              <ErrorMessage
                name="packageAddOnGuestInfo"
                component="div"
                className="error-message"
              />
              <FormSubmit>
                <FormBackButton
                  disabled={disabled}
                  onClick={() => actions.transitionTo('/addons')}
                >
                  Back
                </FormBackButton>
                <FormSubmitButton disabled={disabled}>
                  Continue
                  {disabled ? (
                    <span>
                      &nbsp;
                      <i className="fa fa-spinner fa-pulse" />
                    </span>
                  ) : (
                    ''
                  )}
                </FormSubmitButton>
              </FormSubmit>
              <FormReset>
                <FormResetButton
                  disabled={disabled}
                  onClick={() => {
                    actions.updateSale(emptySale());
                    actions.transitionTo('/');
                  }}
                >
                  Start Over
                </FormResetButton>
              </FormReset>
            </Form>
          );
        }}
      </Formik>
    </FormWrapper>
  );
};

GuestInfoContainer.propTypes = {
  actions: PropTypes.object,
  error: PropTypes.string,
  config: PropTypes.object,
  loading: PropTypes.bool,
  sale: PropTypes.object,
  inventory: PropTypes.object,
  done: PropTypes.bool
};

const mapStateToProps = state => ({
  ...state.sale,
  config: state.config,
  inventory: state.inventory
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(_actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(GuestInfoContainer));
